/** localStorage key for soft site-password unlock. */
export const SITE_PASSWORD_UNLOCK_KEY = 'birdlife-site-unlock' as const;

/** Stored value when the visitor has unlocked the soft gate. */
export const SITE_PASSWORD_UNLOCK_VALUE = '1' as const;

/** Dispatched on `window` after a successful unlock in this tab. */
export const SITE_PASSWORD_UNLOCK_CHANGE_EVENT = 'birdlife:site-password-unlock' as const;

/** `document.documentElement` attribute set before paint while the gate is locked. */
export const SITE_PASSWORD_LOCKED_ATTR = 'data-site-locked' as const;

/** DOM id for the password field in the soft gate form. */
export const SITE_PASSWORD_INPUT_ID = 'site-password-input' as const;
